import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ParameterDto, ParameterItem, UserState } from 'app/shared/models';
import { Observable } from 'rxjs';
import { ConfigurationService } from 'app/shared';

@Injectable({
  providedIn: 'root'
})
export class ParameterService {
  constructor(private _http: HttpClient, private _config: ConfigurationService) {

  }
  listCompanySpecificForReportDefinition(reportDefinitionId: number): Observable<ParameterDto[]> {
    return this._http
      .get<ParameterDto[]>(`${this._config.apiUrl}/api/reportDefinition/${reportDefinitionId}/parameters`);
  }
  listDefaultForReportDefinition(reportDefinitionId: number): Observable<ParameterDto[]> {
    return this._http
      .get<ParameterDto[]>(`${this._config.apiUrl}/api/reportDefinition/${reportDefinitionId}/parameters/default`);
  }

  create(reportDefinitionId: number, model: ParameterDto[]) {
    return this._http
      .post<number>(`${this._config.apiUrl}/api/reportDefinition/${reportDefinitionId}/parameters`, model);
  }

  loadUserState(): Observable<UserState> {
    return this._http
      .get<UserState>(`${this._config.apiUrl}/api/user/parameters`);
  }

  updateUserParameters(parameters: ParameterItem[]): Observable<UserState> {
    return this._http
      .put<UserState>(`${this._config.apiUrl}/api/user/parameters`, { parameters: parameters });
  }
}

